import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { viewAllReviews } from "../../utils/translations";
import { reviews } from "../../utils/reviewsData";
import "./viewAllReviews.css";

export default function AllReviews() {
  const navigate = useNavigate();
  const { language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={`viewAllReviews-page-container ${language === "ar" ? "rtl" : ""} ${language === "ar" ? "arab" : ""}`}
    >
      <h2 className="viewAllReviews-page-title">
        {viewAllReviews[language].allReviews}
      </h2>

      <motion.div
        className="viewAllReviews-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.1,
            },
          },
        }}
      >
        {reviews.map((review) => (
          <motion.div
            key={review.id}
            className="viewAllReviews-reviewCard"
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
            }}
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.5 }}
          >
            <div className="viewAllReviews-reviewerInfo">
              <img
                src={review.image}
                alt={`${review.name}'s profile`}
                className="viewAllReviews-reviewerImage"
              />
              <h3 className="viewAllReviews-reviewerName">{review[language].name}</h3>
            </div>
            <p
              className={`viewAllReviews-reviewerComment ${
                language === "ar" ? "right-to-left" : ""
              }`}
            >
              {review[language].comment}
            </p>
          </motion.div>
        ))}
      </motion.div>

      <div className="viewAllReviews-buttonContainer">
        <button onClick={() => navigate("/")} className={`viewAllReviews-backButton ${language === "ar" ? "right-button" : ""}`}>
          {viewAllReviews[language].backToHome}
        </button>
      </div>
    </div>
  );
}
